window.ytModalPopup = (function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Get the modal
    var modal = document.getElementById("yt-video-modal");

    // Get the <span> element that closes the modal
    var span = document.getElementsByClassName("yt-close")[0];
    var linkSpan = document.getElementsByClassName("yt-close--link")[0];

    // Get the iframe inside the modal
    var iframe = document.getElementById("yt-iframe");

    // Function to extract the YouTube video ID from the URL
    function getYouTubeVideoId(url) {
      var videoId = '';
      var match = url.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      if (match && match[1].length == 11) {
        videoId = match[1];
      }
      return videoId;
    }

    // Function to open the modal
    function openModal(videoId) {
      if (iframe && modal) {
        iframe.src = "https://www.youtube.com/embed/" + videoId + "?autoplay=1";
        modal.style.display = "block";
      }
    }

    // Function to close the modal
    function closeModal() {
      if (modal) {
        modal.style.display = "none";
        if (iframe) {
          iframe.src = ""; // Stop the video
        }
      }
    }

    // Function to dynamically add the data attribute to YouTube links
    function addYouTubeDataAttribute() {
      document.querySelectorAll('a[href*="youtu"]').forEach(function(link) {
        link.setAttribute('data-play-youtube-video', '');
      });
    }

    // When the user clicks on the link, open the modal or fallback to a new tab
    function attachClickHandlers() {
      document.querySelectorAll('a[data-play-youtube-video]').forEach(function(link) {
        link.addEventListener('click', function(event) {
          event.preventDefault(); // Prevent the default link behavior
          var videoUrl = this.getAttribute('href');
          var videoId = getYouTubeVideoId(videoUrl);
          if (videoId) {
            openModal(videoId);
          } else {
            window.open(videoUrl, '_blank');
          }
        });
      });
    }

    // Add the data attribute to YouTube links
    addYouTubeDataAttribute();

    // Attach click handlers to YouTube links
    attachClickHandlers();

    // When the user clicks on <span> (x), close the modal
    if (span) {
      span.onclick = function() {
        closeModal();
      }
    }

    // When the user clicks on <span> (close link), close the modal
    if (linkSpan) {
      linkSpan.onclick = function() {
        closeModal();
      }
    }

    // When the user clicks anywhere outside of the modal, close it
    window.onclick = function(event) {
      if (event.target == modal) {
        closeModal();
      }
    }
  });
})();
